import React, { useEffect, useState } from "react";
import Classes from "./styles/style.module.css";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import EventFilters from "./EventFilters";
import errorHandler from "../../assets/utils/ErrorHandler";
import appApi from "../../assets/utils/AppApi";
import Loading from "../../assets/containers/loadingDialog";
import EventListElement from "./EventListElement";
import NoResultAlter from "../../assets/components/UI/NoResultAlter";

const EventsPage = () => {
  const [filter, setFilter] = useState("");
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAllEvents(filter);
  }, [filter]);

  const getAllEvents = async (search) => {
    setLoading(true);
    try {
      await appApi.get(`/event/getall?searchString=${search}`).then(({ data }) => {
        setEvents(data.events);
        setLoading(false);
      });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  return (
    <AnimatedPageContainer>
      <div className={Classes.container}>
        <div className="w-100">
          <EventFilters
            selected={filter}
            handleClick={(type) => setFilter(type)}
          />
          {loading ? (
            <div className="w-100 d-flex justify-content-center py-5 my-5">
              <Loading size={30} />
            </div>
          ) : events.length !== 0 ? (
            events.map((event, index) => {
              return <EventListElement key={index} event={event} />;
            })
          ) : (
            <NoResultAlter className={"w-100  py-5 my-5"} />
          )}
        </div>
      </div>
    </AnimatedPageContainer>
  );
};

export default EventsPage;
